export const pageName: Record<string, string> = {
  '/custom-travel/[agtName]/[productId]': 'custom_travel_request_main',
  '/custom-travel/[agtName]/[productId]/estimate': 'custom_travel_request_estimate',
  '/custom-travel/[agtName]/[productId]/consulting': 'custom_travel_request_consulting',
  '/custom-travel/[agtName]/[productId]/complete': 'custom_travel_request_complete',
  '/custom-travel/estimate/[estimateId]': 'custom_travel_estimate',
  '/custom-travel/error': 'custom_travel_error',
};
